import ko from 'knockout';

ko.bindingHandlers['invisible'] = {
	update: function (element, valueAccessor) {
		var value = ko.utils.unwrapObservable(valueAccessor());
		element.style.display = value ? "none" : "";
	}
};
